<template>
  <div class="registration">
    <div class="alert alert-danger">Altering the registration form post-launch can have unintended consequences.</div>
    <div class="alert alert-info">Existing fields: First Name, Last Name, Email, Address, City, State, Zipcode</div>
    <!-- main form -->
    <div class="form-container col-sm-6">
      <draggable v-model="registrationForm" @start="drag=true" @end="drag=false">
        <form-item
          v-for="(item, index) in registrationForm" :key="item.uid"
          :inputData="item"
          :index="index"
          ></form-item>
      </draggable>
    </div>
    <!-- sidebar -->
    <side-bar />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import FormItem from '../registrationForm/FormItem'
import SideBar from '../registrationForm/SideBar'
import draggable from 'vuedraggable'

export default {
  name: 'RegistrationContent',
  components: {
    draggable,
    'form-item': FormItem,
    'side-bar': SideBar
  },
  created () {
    this.$bus.on('add-to-form', this.addToForm)
    this.$bus.on('remove-from-form', this.removeFromForm)
  },
  beforeDestroy () {
    this.$bus.off('add-to-form', this.addToForm)
    this.$bus.off('remove-from-form', this.removeFromForm)
  },
  data () {
    return {
      formItems: [],
      generics: {
        text: { uid: null, appendedOutput: null, mergeVar: null, display: true, help_text: null, label: '', name: 'Text', edit: false, type: 'text', required: true, editable: false },
        textarea: { uid: null, appendedOutput: null, mergeVar: null, display: true, help_text: null, label: '', name: 'Textarea', edit: false, type: 'textarea', required: true, editable: false },
        select: { uid: null, appendedOutput: null, mergeVar: null, display: true, help_text: null, label: '', name: 'Select', edit: false, type: 'select', required: true, editable: false, options: [] },
        radio: { uid: null, appendedOutput: null, mergeVar: null, display: true, help_text: null, label: '', name: 'Radio', edit: false, type: 'radio', required: true, editable: false, options: [] },
        checkbox: { uid: null, appendedOutput: null, mergeVar: null, display: true, help_text: null, label: '', name: 'Checkbox', edit: false, type: 'checkbox', required: true, editable: false, options: [] }
      }
    }
  },
  computed: {
    ...mapState('loyaltyProgram', [
      'program'
    ]),
    registrationForm: {
      get () {
        return this.program.registrationForm.formItems
      },
      set (value) {
        this.SET_FORM(value)
      }
    }
  },
  methods: {
    ...mapMutations('loyaltyProgram', [
      'SET_FORM'
    ]),
    ...mapActions('loyaltyProgram', [
      'updateForm'
    ]),
    ...mapMutations('loyaltyProgram', {
      updateProgram: 'UPDATE_PROGRAM'
    }),
    addToForm (elementType) {
      const newItem = Object.assign({}, this.generics[elementType])
      var dt = new Date().getTime()
      newItem.uid = elementType + '-' + dt
      this.updateForm({ add: true, content: newItem })
    },
    removeFromForm (index) {
      this.updateForm({ add: false, content: index })
    }
    // ...mapActions('company', [ 'getCompanies', 'createCompany' ]),
    // ...mapActions('loyaltyProgram', [ 'saveProgram' ]),
    // updateCompany (event) {
    //   this.updateProgram({ prop: 'company', value: event.target.value })
    // }
  }

}
</script>

<style scoped>

</style>
